/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('oauth.verify-email', {
      url: '/verifyemail',
      template: '<verify-email></verify-email>',
      data: { pageTitle: 'Verify email | Verify Email' },
    });
}



// WEBPACK FOOTER //
// ./client/app/oauth/verify-email/verify-email.routes.js